import config from '../config'
import { addAuthToken } from '../helper'


const TaxProfilesManager = {
  createTaxProfile: async (taxInformation, jwt = null) => {
    const request = addAuthToken({
      ...config.POST,
      body: JSON.stringify(taxInformation),
    }, jwt)

    const response = await fetch(`${config.SERVICE_URL}/tax-profiles/v1`, {
      ...request,
    })

    if (!response.ok) {
      throw new Error(`Create tax profile errored with status: ${response.status}`)
    }

    return await response.json()
  },
  updateTaxProfile: async (taxProfile) => {
    const request = addAuthToken({
      ...config.PUT,
      body: JSON.stringify(taxProfile),
    })

    const response = await fetch(`${config.SERVICE_URL}/tax-profiles/v1/${taxProfile._id}`, {
      ...request,
    })

    if (!response.ok) {
      throw new Error(`Update tax profile errored with status: ${response.status}`)
    }

    return await response.json()
  },
  getTaxProfiles: async (companyId) => {
    const request = addAuthToken({
      ...config.GET,
    })

    const response = await fetch(`${config.SERVICE_URL}/tax-profiles/v1?company_id=${companyId}`, {
      ...request,
    })

    if (!response.ok) {
      throw new Error(`Get tax profiles errored with status: ${response.status}`)
    }

    return await response.json()
  },
  uploadW9File: async (companyId, file, jwt = null) => {
    const formData = new FormData()
    formData.append('file', file, `${companyId}/${file.name}`)
    const request = addAuthToken({
      ...config.POST_FORM_DATA,
      body: formData,
    }, jwt)

    const response = await fetch(`${config.SERVICE_URL}/tax-profiles/tax-files/v1`, {
      ...request,
    })

    if (!response.ok) {
      throw new Error(`Upload W9 file errored with status: ${response.status}`)
    }

    return await response.json()
  },
}

export default TaxProfilesManager
